import produce from 'immer'
import {
  UI_LOAD,
  UI_LOAD_SUCCESS,
  UI_SET_SIDEBAR_COLLAPSED,
  UI_SET_DELIVERY_TABLE_COLUMNS,
  UI_SET_WASTE_TABLE_COLUMNS,
  UI_SET_ORDERED_DELIVERY_TABLE_COLUMNS,
  UI_SET_ORDERED_WASTE_TABLE_COLUMNS,
  UI_SET_SHOWN_DELIVERY_TABLE_COLUMNS,
  UI_SET_SHOWN_WASTE_TABLE_COLUMNS
} from './actions'

const initialState = {
  loading: false,
  error: null,
  data: {
    sidebarCollapsed: false,
    deliveryTableColumns: [],
    deliveryOrderedTableColumns: [],
    deliveryShownTableColumns: [],
    wasteTableColumns: [],
    wasteOrderedTableColumns: [],
    wasteShownTableColumns: []
  }
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case UI_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case UI_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.ui
        return
      }
      case UI_SET_SIDEBAR_COLLAPSED: {
        draft.data.sidebarCollapsed = action.collapsed
        return
      }
      case UI_SET_DELIVERY_TABLE_COLUMNS: {
        draft.data.deliveryTableColumns = action.columns
        return
      }
      case UI_SET_WASTE_TABLE_COLUMNS: {
        draft.data.wasteTableColumns = action.columns
        return
      }
      case UI_SET_ORDERED_DELIVERY_TABLE_COLUMNS: {
        draft.data.deliveryOrderedTableColumns = action.columns
        return
      }
      case UI_SET_ORDERED_WASTE_TABLE_COLUMNS: {
        draft.data.wasteOrderedTableColumns = action.columns
        return
      }
      case UI_SET_SHOWN_DELIVERY_TABLE_COLUMNS: {
        draft.data.deliveryShownTableColumns = action.columns
        return
      }
      case UI_SET_SHOWN_WASTE_TABLE_COLUMNS: {
        draft.data.wasteShownTableColumns = action.columns
        return
      }
      default:
        return
    }
  })
